import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/toxicologia/informes-sobre-disolventes-residuales")({
  beforeLoad: () => { throw redirect({ href: "/es/servicios/toxicologia-regulatoria/informes-sobre-disolventes-residuales", statusCode: 301 }); },
});
